import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizOptions from "../shared/QuizOptions";
import BackgroundVideo from "../shared/BackgroundVideo";
import PromotionContent from "../shared/PromotionContent";
import { VIDEO_URLS } from "../../utils/videoConfig";

const Step5 = ({ onContinue }) => {
  return (
    <QuizContent>
      <QuizOptions>
        <BackgroundVideo src={VIDEO_URLS.video3} />
        <PromotionContent onContinue={onContinue}>
          <h2>
            <strong>
              An AI friend can offer fun conversations, support and advice
              anytime you need it
            </strong>
          </h2>
        </PromotionContent>
      </QuizOptions>
    </QuizContent>
  );
};

export default Step5;
